/**
 *
 * @author: Huning
 * @date: 2019-07-10
 *
 */
import React, { PureComponent, Fragment } from 'react'
import { Button } from 'antd'
import PropTypes from 'prop-types'
import FilterButton from './filter-button'
import FilterContent from './filter-content'
import style from './index.less'

class FilterLayout extends PureComponent {
  static propTypes = {
    onClickReset: PropTypes.func,
    onClickSearch: PropTypes.func,
    hideDefaultAction: PropTypes.bool
  }

  static defaultProps = {}

  state = {
    openFilter: false
  }

  componentDidMount() {}

  handleFilterOpen = () => {
    this.setState(state => ({ openFilter: !state.openFilter }))
  }

  render() {
    const { props, state } = this
    const { openFilter } = state
    const {
      outsideForm,
      insideForm,
      renderAction,
      hideDefaultAction,
      onClickSearch,
      onClickReset
    } = props
    return (
      <Fragment>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {outsideForm}
          <FilterButton open={openFilter} onClick={this.handleFilterOpen} />
        </div>
        <FilterContent open={openFilter}>
          {insideForm}
          {hideDefaultAction || renderAction ? (
            renderAction || ''
          ) : (
            <div className={style['filter-action']}>
              <Button type="primary" htmlType="submit" onClick={onClickSearch}>
                搜索
              </Button>
              <Button style={{ marginLeft: 8 }} onClick={onClickReset}>
                清空
              </Button>
              <Button type="link" onClick={this.handleFilterOpen}>
                收起
              </Button>
            </div>
          )}
        </FilterContent>
      </Fragment>
    )
  }
}

export default FilterLayout
